module.exports = __webpack_public_path__ + "img/sm-act.441a54cb.png";